import React, { useState } from "react";
import ProductCard from "../ProductCard/ProductCard";
import viewboardList from "./viewboardModelList";
import Logo from "../Splash/Logo";
import { Flex } from "@chakra-ui/react";

const SPLASH_DONE_KEY = "viewAR_splash_done";
const IFP_SERIES_ORDER = [
    "IFP32 Series",
    "IFP33 Series",
    "IFP50 Series",
    "IFP51 Series",
    "IFP52 Series",
    "IFP52-2F Series",
    "IFP62 Series",
    "IFP110 Series",
    "IFPG1 Genesis Series OS-Free",
    "IFP Ultrawide Series",
];

function Home({ viewboardDetails, countryList }) {
    const [isLoading, setIsLoading] = useState(
        () => sessionStorage.getItem(SPLASH_DONE_KEY) !== "1"
    );
    const [closeCard, setCloseCard] = useState(null);

    const handleAnimationEnd = () => {
        sessionStorage.setItem(SPLASH_DONE_KEY, "1");
        setIsLoading(false);
    };

    function handleCardCollapse(funcCloseCard) {
        if (closeCard && funcCloseCard) closeCard();
        setCloseCard(() => funcCloseCard);
    }

    const orderedSeries = viewboardDetails.series
        ? Object.values(viewboardDetails.series).sort((a, b) => {
              const aIndex = IFP_SERIES_ORDER.indexOf(a.name);
              const bIndex = IFP_SERIES_ORDER.indexOf(b.name);
              const safeAIndex = aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex;
              const safeBIndex = bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex;
              return safeAIndex - safeBIndex;
          })
        : [];

    return (
        <>
            {isLoading ? (
                <>
                    <Logo onAnimationEnd={handleAnimationEnd}></Logo>
                </>
            ) : (
                <>
                    <Flex
                        direction="column"
                        w="full"
                        p="14px"
                        gap="17px"
                    >
                        {orderedSeries.map((value, index) => {
                            return (
                                <ProductCard
                                    key={`collapse${index}`}
                                    series={value}
                                    countryList={countryList}
                                    defaultArModel={
                                        value.pixelPitch
                                            ? (value.pixelPitch.find(
                                                  (p) => !p.disabled,
                                              )?.model ?? value.size[0].model)
                                            : value.size[0].model
                                    }
                                    seriesName=""
                                    closeCardEvent={handleCardCollapse}
                                    viewboardList={Object.entries(viewboardList)}
                                />
                            );
                        })}
                    </Flex>
                </>
            )}
        </>
    );
}

export default Home;
